<template>
  <div>
    <slotBase :bg-grey="true" :loading="isLoading">
      <template v-slot:title>
        <titleBar :header-title="'Riwayat'" @back="back" />
        <div class="p-x-20 p-b-16">
          <dropdownTransaksi />
          <!-- <dropdownEpay /> -->
          <!-- d-flex justify-content-around p-a-10 gap-2 -->
        </div>
      </template>

      <template v-slot:content>
        <template v-if="lengthRiwayat == 0">
          <emptyData :message="'Belum ada transaksi'" />
        </template>
        <div
          class="main-content p-x-20 d-flex flex-column justify-content-center"
        >
					<div class="overlay" v-show="isLoadingDetail">
						<div class="relative">
							<div class="spinner-wrap">
								<div class="spinner-border text-primary absolute" />
							</div>
						</div>
					</div>
          <template v-for="(riwayat, index) in dataHistory">
            <template v-if="riwayat.ref_type !== null">
              <div
                class="d-flex flex-column align-items-start"
                style="gap: 16px"
                :key="index"
              >
                <template v-if="riwayat.ref_type == 'separator'">
                  <p class="f-Overpass f-16 f-w-600 f-c-grey m-0 p-t-16">
                    {{ $moment(riwayat.date).format("MMMM YYYY") }}
                  </p>
                </template>
								<RiwayatCard
									v-else
									@click="openRiwayat(riwayat)"
									:data="riwayat"
								/>
              </div>
            </template>
          </template>
        </div>
        <template v-if="lengthRiwayat !== 0">
          <loadData
            v-if="lengthRiwayat >= pagination.skip"
            :is-loading="lengthRiwayat >= pagination.skip"
            @intersect="!isLoadingMore && loadData()"
          />
        </template>
      </template>
      <template v-slot:footer-bottom>
        <bottomBar :riwayat-page="true" />
      </template>
    </slotBase>
		<ModalRiwayat ref="modalRiwayatRef"/>
  </div>
</template>

<script>
/* eslint-disable */
import slotBase from "@/components/slots/slotBase.vue";
import titleBar from "@/components/design/titleBar.vue";
import cardOut from "../components/cardOut.vue";
import cardIn from "../components/cardIn.vue";
import dropdownTransaksi from "../components/dropDown.vue";
// import dropdownEpay from "../components/dropFilterEpay.vue";
import bottomBar from "@/components/design/bottomBar.vue";
import emptyData from "@/components/design/emptyData.vue";
import { mapState, mapActions } from "vuex";
import loadData from "@/components/fuctions/loadData.vue";
import RiwayatCard from "../components/riwayatCard.vue";
import ModalRiwayat from "../components/modal/modalRiwayat.vue";

export default {
  name: "riwayatPage",
  components: {
    slotBase,
    titleBar,
    cardOut,
    dropdownTransaksi,
    // dropdownEpay,
    bottomBar,
    loadData,
    cardIn,
    emptyData,
		RiwayatCard,
		ModalRiwayat,
  },

  data() {
    return {
      isLoading: false,
      isLoadingMore: false,
			isLoadingDetail: false,
    };
  },

  computed: {
    ...mapState("riwayat", {
      dataHistory: "dataHistory",
      pagination: "pagination",
      lengthRiwayat: "lengthRiwayat",
			detailTopUpToModal: "detailTopUpToModal", //getDetailTopUp
			detailSnap: "detailSnap", //getDetailSnap
    }),
  },

  mounted() {
    this.isLoading = true;
    let data = {
      skip: this.pagination.skip,
      limit: this.pagination.limit,
      jenis: "",
      outlet: "",
    };
    this.postHistory(data).then((res) => {
      if (res.status == 200) {
      }
		}).catch((err) => {
			this.$toast.error(err, { position: "top" });
		}).finally(() => {
			this.isLoading = false
		})
  },

  methods: {
    ...mapActions({
      postHistory: "riwayat/postHistory",
      resetPagination: "riwayat/resetPagination",
			getDetailTopUp: "riwayat/getDetailTopUp",
			getDetailSnap: "riwayat/getDetailSnap",
			getDetailSnapHapus: "riwayat/getDetailSnapHapus",
			getDetailRefund: "riwayat/getDetailRefund",
    }),
		async openRiwayat(riwayat) {
			this.isLoadingDetail = true
			const {ref_id, ref_type} = riwayat

			let data = {
				ref_type,
				ref_id,
			}
			let action;
			
			switch (ref_type) {
				case 'snap_transaksi':
					data.title = 'Transaksi'
					action = () => this.getDetailSnap(ref_id);
					break;
				case 'pembelian_emoney':
					data.title = 'Top-Up'
					action = () => this.getDetailTopUp(ref_id);
					break;
				case 'snap_transaksi_hapus':
					data.title = 'Penghapusan'
					action = () => this.getDetailSnapHapus(ref_id);
					break;
				case 'snap_transaksi_refund':
					data.title = 'Refund'
					action = () => this.getDetailRefund(ref_id);
				default:
					break;
			}

			action().then(() => {
				this.$refs.modalRiwayatRef.open(data)
			}).catch((err) => {
				let toastMessage = err
				if (err.response.status == 404) {
					toastMessage = 'Transaksi ini gagal dibuat'
					if (ref_type != 'snap_transaksi') {
						toastMessage = 'Transaksi ini tidak ditemukan'
					}
				}
				this.$toast.error(toastMessage, { position: "top" });
			}).finally(() => {
				this.isLoadingDetail = false
			})
		},
    back() {
      this.$router.replace({ name: "dashboardUtama" });
    },

    loadData() {
      let data = {
        skip: this.pagination.skip,
        limit: this.pagination.limit,
        jenis: this.pagination.jenis,
        outlet: this.pagination.outlet,
      };
      this.postHistory(data);
    },
  },
};
</script>
<style scoped>
.overlay {
	transition: all 0.5s ease;
	position: fixed;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 4;
	cursor: pointer;
}
.overlay .relative {
	position: relative;
	width: 100%;
	height: 100%;
}
.overlay .spinner-wrap {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}
</style>
